<template
  ><v-card class="p-4">
    <v-card-title>
      Les droits utilisateurs
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Rechercher sur les noms"
        single-line
        hide-details
      ></v-text-field>
      <v-spacer></v-spacer>

      <export-btn entity="user_rights"/>

      <!-- bouton trash à partir de 2 checkbox de cocher -->
      <v-btn v-if="selected.length >= 2" class="mx-2" fab dark small color="red" data-toggle="tooltip" title="Suppression des droits utilisateurs sélectionnés">
        <v-icon dark v-model="selected" small @click="deleteUserRights(selected[0].userRight)">
          mdi-delete
        </v-icon>
      </v-btn>

      <v-btn class="mx-2" fab dark small color="indigo" data-toggle="tooltip" title="Ajout d'un droit utilisateur">
        <v-icon dark small @click.stop="dialog = true">
          mdi-plus
        </v-icon>
      </v-btn>

    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="userRights"
      :search="search"
      :items-per-page="12"
      :page.sync="pagination.currentPage"
      @page-count="pageCountChange"
      hide-default-footer
      v-model="selected"
      :single-select="singleSelect"
      show-select
    >
    <template v-slot:item.createdAt="{ item }">
      <span>{{ item.createdAt|moment }}</span>
    </template>

      <template v-slot:[`item.actions`]="{ item }">
        <router-link :to="{
            name: 'modifierDroitUtilisateur',
            params: { id: item.id, userRight: item },
          }">
          <v-icon small class="mr-2">mdi-pencil</v-icon>
        </router-link>

        <v-icon class="pl-2" small @click="deleteUserRight(item)">mdi-delete</v-icon>

      </template>
    </v-data-table>

    <AddUserRightModal
      :userRights="userRights"
      :dialog="this.dialog"
      @onClose="dialog=false"
      @submit="submit"
    ></AddUserRightModal>

    <v-pagination
      v-model="pagination.currentPage"
      :length="pagination.pagesNumber"
      class="pt-5"
    ></v-pagination>
  </v-card>
</template>

<style scoped>
::v-deep .v-data-table__empty-wrapper {
  display: none;
}
</style>
<script>

//import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import Api from "@/core/services/api.service";
import Swal from "sweetalert2";
import moment from "moment";
import AddUserRightModal from "@/components/admin/userRight/modal/addUserRightModal";
import ExportBtn from "@/components/admin/exportBtn";

export default {
  name: "userRights",
  components: { AddUserRightModal, ExportBtn },
  data() {
    return {
      confirmDelete: false,
      loading: true,
      options: {},
      search: "",
      headers: [
        { text: "Titre du droit utilisateur", value: "name", align: "start" },
        { text: "Thèmes", value: "themes.length", align: "start" },
        // { text: "Parcours", value: "courses.length", align: "start" },
        { text: "Utilisateurs", value: "users.length", align: "start" },
        { text: "Clients", value: "clients.length", align: "start" },
        { text: "Crée le", value: "createdAt", align: "start" },
        { text: "Actions", value: "actions", sortable: false, align: "center" },
      ],
      pagination: {
        currentPage: 1,
        pagesNumber: 0,
      },
      deletedIndex: -1,
      singleSelect: false,
      selected: [], // Liste des droits utilisateurs sélectionnés dans le tableau
      userRights: [],
      themeSelected: null,
      dialog: false,
    };
  },

  filters: {
    moment: function(date) {
      return moment(date).format("DD/MM/YYYY");
    },
  },

  methods: {
    getAllUserRights() {
      this.loading = true;

      Api.get("user_rights?pagination=false")
      .then((userRights) => {
        this.userRights = userRights.data["hydra:member"]; //On rempli le tableau initialement vide par ce qu'on a récupéré
        // this.pagination.pagesNumber = Math.ceil(
        //   userRights.data["hydra:totalItems"] / 12 //12 car côté API le nombre de userRight est réglé a 12 par page
        // );
      this.loading = false;
      });
    },

    deleteUserRight(item) {
      if(item.users.length === 0){
        Swal.fire({
          title: "Voulez-vous vraiment supprimer ce droit utilisateur ?",
          text: "Attention, cette action est irréversible !",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Oui, supprimer",
          cancelButtonText: "Annuler",
        }).then((result) => {
          if (result.isConfirmed) {
            this.deletedIndex = this.userRights.indexOf(item);
            Api.delete("user_rights/" + item.id).then(() => {
              this.userRights.splice(this.deletedIndex, 1),
                Swal.fire(
                  "Supprimé !",
                  "Votre droit utilisateur a été supprimé",
                  "success"
                ),
                this.getAllUserRights();
            });
          }
        })}else{
          Swal.fire(
          "Attention",
          "Votre droit utilisateur est encore associé à d'autres utilisateurs, il ne peut donc être supprimé",
          "error"
          )}
    },

    deleteUserRights() {
      const selectedItems = this.selected
      let deletable = true // select userRight qui n'ont pas d'utilisateur
      for(var i=0; i < selectedItems.length; i++){
        if(selectedItems[i].users.length > 0) {
          deletable = false
        }
      }
      if(deletable){
        Swal.fire({
          title: "Voulez-vous vraiment supprimer ce droit utilisateur ?",
          text: "Attention, cette action est irréversible !",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Oui, supprimer",
          cancelButtonText: "Annuler",
        })
        .then((result) => {
          if (result.isConfirmed) {
            const selectedItems = this.selected
            for(var i=0; i < selectedItems.length; i++){
            Api.delete("user_rights/" + selectedItems[i].id).then(() => {
              Swal.fire(
                "Supprimé !",
                "Votre droit utilisateur a été supprimé",
                "success"
              )
              //this.selected = [];
              this.getAllUserRights();
            });
            }
          }
        })
      }else{
        Swal.fire(
          "Attention",
          "Votre droit utilisateur est encore associé à d'autres utilisateurs, il ne peut donc être supprimé. Merci de vérifier votre sélection et déselectionner le droit utilisateur ayant un nombre d'utilisateur différent de 0.",
          "error"
        )
      }
    },

    submit: async function(userRight) {
      try {
        // récupération du droit utilsateur qui vient juste d'être créer puis modifier
        const response = await Api.post("user_rights", {
          name: userRight.name,
          clients: userRight.clients.map(c=>c['@id']),
          themes: userRight.themes.map(t=>t['@id']),
        });
          Swal.fire({
          title: "",
          text: "Le droit utilisateur a été crée.",
          icon: "success",
          confirmButtonClass: "btn btn-secondary",
        });
        this.$router.push({
          name: 'modifierDroitUtilisateur',
          params: { id: response.data.id, userRight: response.data },
        })
      } catch (error) {
        Swal.fire({
          title: "",
          text: "Une erreur est survenue lors de la création du droit utilisateur",
          icon: "error",
          confirmButtonClass: "btn btn-secondary",
        });
      }
    },
    
    pageCountChange(pageCount) {
      this.pagination.pagesNumber = pageCount;
    }
  },

  mounted() {
    this.getAllUserRights();
  }
}
</script>
